<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::sidebar-->
      <navbar-component></navbar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <div class="page-content">
          <div class="row">
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    Create DO
                  </h6>
                  <button
                    class="btn btn-success btn-xs float-end"
                    @click="resetForm"
                    type="button"
                  >
                    <i class="mdi mdi-reload"></i>
                    Reset Form
                  </button>
                </div>
                <div class="card-body">
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                    id="mainForm"
                  >
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label
                              for="defaultconfig"
                              class="col-form-label"
                              style="padding-left: 25px"
                              >Order Date</label
                            >
                          </div>
                          <div class="col-lg-6">
                            <input
                              type="text"
                              readonly
                              class="form-control"
                              :value="this.$moment().format('YYYY-MM-DD')"
                            />
                          </div>
                        </div>
                        <!-- <div class="row mb-3">
                          <div class="col-lg-4">
                            <label
                              for="defaultconfig"
                              class="col-form-label"
                              style="padding-left: 25px"
                              >Do Number</label
                            >
                          </div>
                          <div class="col-lg-6">
                            <input
                              type="text"
                              class="form-control"
                              v-model="forms.soReference1"
                            />
                          </div>
                        </div> -->
                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label
                              for="defaultconfig"
                              class="col-form-label"
                              style="padding-left: 25px"
                              >Description</label
                            >
                          </div>
                          <div class="col-lg-6">
                            <textarea
                              class="form-control"
                              v-model="forms.soReference3"
                            ></textarea>
                            <div v-if="errors.soReference3">
                              <div
                                v-for="error in errors.soReference3"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label
                              for="defaultconfig"
                              class="col-form-label required"
                              style="padding-left: 25px"
                              >Destination</label
                            >
                          </div>
                          <div class="col-lg-6">
                            <v-select
                              v-model="vendor"
                              :options="fetchVendor"
                              @search="asyncVendor"
                              @input="vendorChanged"
                              label="customerDescr1"
                            ></v-select>

                            <div v-if="errors.consigneeId">
                              <div
                                v-for="error in errors.consigneeId"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label
                              for="defaultconfig"
                              class="col-form-label required"
                              style="padding-left: 25px"
                              >Up / Consignee</label
                            >
                          </div>
                          <div class="col-lg-6">
                            <input
                              type="text"
                              class="form-control"
                              v-model="forms.consigneeName"
                            />

                            <div v-if="errors.consigneeName">
                              <div
                                v-for="error in errors.consigneeName"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label
                              for="defaultconfig"
                              class="col-form-label"
                              style="padding-left: 25px"
                              >Address 1</label
                            >
                          </div>
                          <div class="col-lg-6">
                            <textarea
                              class="form-control"
                              readonly
                              v-model="forms.consigneeAddress1"
                            ></textarea>
                          </div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label
                              for="defaultconfig"
                              class="col-form-label"
                              style="padding-left: 25px"
                              >Address 2</label
                            >
                          </div>
                          <div class="col-lg-6">
                            <textarea
                              class="form-control"
                              readonly
                              v-model="forms.consigneeAddress2"
                            ></textarea>
                          </div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label
                              for="defaultconfig"
                              class="col-form-label"
                              style="padding-left: 25px"
                              >Address 3</label
                            >
                          </div>
                          <div class="col-lg-6">
                            <textarea
                              class="form-control"
                              readonly
                              v-model="forms.consigneeAddress3"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label
                              for="defaultconfig"
                              class="col-form-label required"
                              style="padding-left: 25px"
                              >Delivery Method</label
                            >
                          </div>
                          <div class="col-lg-6">
                            <v-select
                              v-model="forms.carrierName"
                              :options="['REGULAR', 'URGENT']"
                            ></v-select>
                            <div v-if="errors.carrierName">
                              <div
                                v-for="error in errors.carrierName"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label
                              for="defaultconfig"
                              class="col-form-label required"
                              style="padding-left: 25px"
                              >Carrier</label
                            >
                          </div>
                          <div class="col-lg-6">
                            <v-select
                              v-model="forms.carrierId"
                              :options="['TIKI', 'SICEPAT']"
                            ></v-select>
                            <div v-if="errors.carrierId">
                              <div
                                v-for="error in errors.carrierId"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <!-- <button class="btn float-start btn-warning mx-2 btn-lg my-2"> Back</button> -->
                        <button
                          @click="addRow"
                          class="btn float-start btn-success mx-2 btn-lg my-2"
                          type="button"
                        >
                          <i class="mdi mdi-plus"></i> Add Sku
                        </button>
                        <button
                          class="btn float-start btn-warning mx-2 btn-lg my-2"
                          @click="uploadSku"
                          type="button"
                        >
                          <i class="mdi mdi-upload"></i> Upload Detail
                        </button>
                      </div>
                    </div>
                    <div class="row">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <td>No</td>
                            <td>Sku</td>
                            <td>Sku Description</td>
                            <td>Qty</td>
                            <td>Qty Available</td>
                            <td>UOM</td>
                            <td>Action</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(list, key) in rows" :key="key">
                            <td>{{ key + 1 }}</td>
                            <td style="width: 25%">
                              <v-select
                                v-show="list.isEdit"
                                v-model="list.skus"
                                :options="fetchSku"
                                @search="asyncSearchSku"
                                @input="skuChanged($event, key, list)"
                                :filterBy="customFilterSku"
                                label="sku"
                              >
                                <template v-slot:option="option">
                                  {{ option.sku }} | {{ option.skuDescr1 }}
                                </template>
                              </v-select>
                              <span v-show="!list.isEdit">{{ list.sku }}</span>
                            </td>
                            <td>{{ list.skuDescr }}</td>
                            <td>
                              <div v-show="list.isEdit">
                                <input
                                  type="number"
                                  class="form-control"
                                  v-model="list.qty"
                                  :class="list.isInvalidQty ? 'is-invalid' : ''"
                                />
                                <label
                                  id="name-error"
                                  v-show="list.isInvalidQty"
                                  class="error invalid-feedback"
                                  for="name"
                                  >Invalid Qty</label
                                >
                              </div>

                              <span v-show="!list.isEdit">{{ list.qty }}</span>
                            </td>
                            <td>
                              <div
                                class="spinner-border text-primary"
                                role="status"
                                v-show="list.loadingInventory"
                              >
                                <span class="visually-hidden">Loading...</span>
                              </div>
                              <span v-show="!list.loadingInventory">{{
                                list.qtyAvailable
                              }}</span>
                            </td>
                            <td>{{ list.dedi04 }}</td>
                            <td>
                              <!-- v-show="list.isEdit" -->
                              <button
                                class="btn btn-icon btn-success mx-1"
                                v-show="list.isEdit"
                                type="button"
                                @click.prevent="doneEdit(key, list)"
                              >
                                <i class="mdi mdi-check"></i>
                              </button>
                              <button
                                class="btn btn-icon btn-danger mx-1"
                                v-show="list.isEdit"
                                type="button"
                                @click.prevent="removeRow(list, key)"
                              >
                                <i class="mdi mdi-delete"></i>
                              </button>
                              <button
                                class="btn btn-icon btn-warning mx-1"
                                v-show="!list.isEdit"
                                type="button"
                                @click.prevent="editData(key, list)"
                              >
                                <i class="mdi mdi-pencil"></i>
                              </button>
                              <button
                                class="btn btn-icon btn-danger mx-1"
                                type="button"
                                @click.prevent="deleteRow(list, key)"
                                v-show="!list.isEdit"
                              >
                                <i class="mdi mdi-delete"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </form>
                </div>
                <div class="card-footer">
                  <button
                    class="btn btn-primary float-end btn-sm"
                    form="mainForm"
                    type="submit"
                  >
                    <i class="link-icon" data-feather="save"></i>
                    {{ $t("submitFormTxt") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <footer-component></footer-component>

          <modal
            name="uploadSku"
            :draggable="false"
            :scrollable="true"
            :height="'auto'"
          >
            <div
              class="modal fade show"
              tabindex="-1"
              style="display: block; margin-top: 2%"
              aria-modal="true"
              role="dialog"
            >
              <div class="modal-dialog modal-md modal-dialog-centered">
                <div class="modal-content">
                  <form
                    class="forms-sample"
                    @submit.prevent="submitUpload"
                    method="POST"
                  >
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">
                        Upload Detail
                      </h5>
                      <button
                        type="button"
                        class="btn-close"
                        aria-label="btn-close"
                        @click.prevent="removeModals()"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <div class="row mb-3">
                        <div class="col-lg-3">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >Files</label
                          >
                        </div>
                        <div class="col-lg-9">
                          <input
                            type="file"
                            class="form-control"
                            ref="fileUpload"
                            @change="handleFileUpload($event)"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click.prevent="removeModals()"
                      >
                        {{ this.$t("close_txt") }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-warning"
                        @click="downloadTemplate"
                      >
                        Download Template
                      </button>
                      <button type="submit" class="btn btn-primary">
                        {{ this.$t("save_change_txt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import readXlsxFile from "read-excel-file";
export default {
  name: "BcafinCustom",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      permision_role: [],
      isLoading: false,
      timeout: null,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      forms: [],
      rows: [],

      fetchVendor: [],
      vendor: null,
      fetchSku: [],
      uploadFiles: null,
    };
  },
  computed: {},
  methods: {
    handleFileUpload(event) {
      this.uploadFiles = event.target?.files[0];
    },
    submitUpload() {
      readXlsxFile(this.uploadFiles).then(async (rows) => {
        rows.forEach(async (item, key) => {
          if (key > 0) {
            let row = {
              skus: { sku: item[0] },
              sku: item[0],
              qty: item[1],
              dedi04: item[2],
            };

            
            // Validate Duplicate Sku
            let check = true;
            for (let index = 0; index < this.rows.length; index++) {
              if (row.sku === this.rows[index].sku) {
                this.showToast("Duplicate Sku Found At Line " + (key++),"error");
                check = false;
              }
            }
            // Skip Insert for duplicate sku
            if (!check) {
              return;
            }

            let skuDetail = await this.getDetailSku(item[0]);
            if (skuDetail) {
              row.skuDescr = skuDetail.skuDescr1;
              row.loadingInventory = true;
              row.isEdit = true;
              await this.getInventory(row);
              this.rows.push(row);
            } else {
              this.showToast(item[0] + " Not Found !!!","error");
            }
          }
        });
      });

      if (this.checkForDuplicates(this.rows, "sku")) {
        this.error("Duplicate Sku Found !!!");
      }

      this.$modal.hide("uploadSku");
    },

    checkForDuplicates(source, keyName) {
      return (
        source.filter((item, index, array) => {
          return array.findIndex((t) => t[keyName] === item[keyName]) === index;
        }).length !== source.length
      );
    },

    async getDetailSku(sku) {
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/sku/index?customerId=BCAFIN&sku=" +
        sku +
        "&limit=1";
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          let resp = response.data.datas.data;
          if (resp.length > 0) {
            return resp[0];
          } else {
            return false;
          }
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
          return false;
        });
    },
    uploadSku() {
      this.$modal.show("uploadSku");
    },
    removeModals() {
      this.$modal.hide("uploadSku");
    },
    doneEdit(index, row) {
      if (this.validateRow(row)) {
        this.$delete(row, "isEdit");
        this.$delete(row, "isInvalidQty");
      }
    },
    downloadTemplate() {
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/interface/bcafin/download-template-sku";
      var file_name = "template-upload-detail.xlsx";

      return this.$http
        .get(baseURI, {
          responseType: "blob",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    validateRow(row) {
      let res = true;
      if (row.sku == null || row.sku == undefined) {
        this.error("Please Select Sku");
        res = false;
      }
      if (row.qty <= 0 || row.qty == null || row.qty == undefined) {
        this.error("Empty Qty");
        this.$set(row, "isInvalidQty", true);
        res = false;
      } else {
        if (row.qty > row.qtyAvailable) {
          this.error("Invalid Qty");
          this.$set(row, "isInvalidQty", true);
          res = false;
        }
      }

      return res;
    },

    editData(index, row) {
      this.$set(row, "isEdit", true);
    },
    deleteRow(list, key) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.rows.splice(key, 1);
        }
      });
    },
    removeRow(list, key) {
      this.rows.splice(key, 1);
    },
    loadSku() {
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/inventory/summary-inventory?warehouseId=CBT01&customerId=BCAFIN&limit=20";
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchSku = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    asyncSearchSku(ev) {
      this.fetchSku = [];
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/inventory/summary-inventory?warehouseId=CBT01&customerId=BCAFIN&limit=20&search=" +
        ev;
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchSku = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    skuChanged(ev, key, list) {
      if (ev !== undefined && ev !== null) {
        let checkDuplicate = false;
        this.rows.forEach((item, keys) => {
          if (keys !== key) {
            if (item.sku == ev.sku) {
              this.error("Duplicate Sku Found !!!");
              checkDuplicate = true;
            }
          }
        });
        if (!checkDuplicate) {
          list.skuDescr = ev.skuDescr1;
          list.dedi04 = ev.uomDescr;
          list.sku = ev.sku;
          list.qtyAvailable = parseInt(ev.qtyAvailed);
        } else {
          list.skuDescr = null;
          list.dedi04 = null;
          list.skus = null;
          list.qtyAvailable = null;
          list.qty = null;
        }
      } else {
        list.skuDescr = null;
        list.dedi04 = null;
        list.qty = null;
        list.qtyAvailable = null;
      }
    },
    customFilterSku(option, label, search) {
      return (
        option.sku.toLowerCase().includes(search.toLowerCase()) ||
        option.skuDescr1.toLowerCase().includes(search.toLowerCase())
      );
    },
    getInventory(list) {
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/inventory/summary-inventory?warehouseId=CBT01&customerId=BCAFIN&sku_code=" +
        list.sku +
        "&reportUom=" +
        list.dedi04;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          let res = response.data.datas.data;
          if (res.length > 0) {
            var qty = 0;
            res.forEach((item) => {
              qty += parseInt(item.qtyAvailed);
            });
            list.qtyAvailable = qty;
            if(qty < list.qty){
              this.showToast("Inventory Can't Fulfill for Sku "+list.sku,'warning');
              list.isInvalidQty = true;
            }else{
              list.isEdit = false;
            }
            this.$delete(list, "loadingInventory");
          } else {
            list.qtyAvailable = 0;
            this.$delete(list, "loadingInventory");
          }
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
          this.error("Something Wrong !!!");
          list.qtyAvailable = 0;
          this.$delete(list, "loadingInventory");
        });
    },
    loadVendor() {
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/vendor/index?refOwner=BCAFIN&customerType=CO";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchVendor = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    asyncVendor(ev) {
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/vendor/index?refOwner=BCAFIN&customerType=CO&customerDescr1=" +
        ev;
      this.fetchVendor = [];

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchVendor = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    vendorChanged(ev) {
      if (ev !== undefined && ev !== null) {
        this.forms.consigneeAddress1 = ev.address1;
        this.forms.consigneeAddress2 = ev.address2;
        this.forms.consigneeAddress3 = ev.address3;
        this.forms.consigneeCity = ev.city;
        this.forms.consigneeCountry = ev.country;
        this.forms.consigneeId = ev.customerId;
        this.forms.consigneeStreet = ev.customerDescr1;
        this.forms.consigneeTel1 = ev.contact1_tel1;
        this.forms.consigneeContact = ev.contact1;
      } else {
        this.forms.consigneeAddress1 = "";
        this.forms.consigneeAddress2 = "";
        this.forms.consigneeAddress3 = "";
        this.forms.consigneeCity = "";
        this.forms.consigneeCountry = "";
        this.forms.consigneeId = "";
        this.forms.consigneeStreet = "";
        this.forms.consigneeTel1 = "";
        this.forms.consigneeContact = "";
      }
    },
    async submitData() {
      if (await this.validateRows()) {
        this.isLoading = true;
        let formData = new FormData();
        Object.keys(this.forms).forEach((key) => {
          let val = this.forms[key];
          formData.append(key, val ? val : "");
        });

        var i = 0;
        this.rows.forEach((item) => {
          Object.keys(item).forEach((key) => {
            let val = item[key];
            formData.append(`details[${i}][${key}]`, val ? val : "");
          });
          i = i + 1;
        });

        const baseURI =
          this.$settings.endPointFluxOms + "v2/interface/bcafin/store";
        this.$http
          .post(baseURI, formData)
          .then((response) => {
            if (response.data.status === 200) {
              this.errors = [];
              this.$swal.fire({
                title: "Success",
                icon: "success",
                text:
                  "Order Created With Reference : " +
                  response?.data.datas.docNo,
              });
              this.resetForm();
            } else {
              this.errors = response.data.errors;
              this.resultError(response.data.errors);
            }
            this.loading();
          })
          .catch((error) => {
            this.loading();
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          });
      }
    },
    async validateRows() {
      let list = [...this.rows];
      let res = true;
      let err = "";
      if (list.length > 0) {
        list.forEach((item, key) => {
          let rowNumber = key + 1;
          this.$toast.error("Line No " + key + 1);
          if (item.isEdit) {
            res = false;
            err += "Row " + rowNumber + " On Edit Mode";
            // this.$toast.error(item)
          }
        });
      } else {
        err += "Empty Detail !!";
        res = false;
      }

      if (!res) {
        this.$swal.fire({
          title: "Error",
          icon: "error",
          html: err,
        });
      }
      return res;
    },
    generateUniqueId() {
      return "id-" + Date.now() + "-" + Math.floor(Math.random() * 10000);
    },
    addRow() {
      this.rows.push({
        id: this.generateUniqueId(),
        isEdit: true,
      });
    },
    resetForm() {
      this.forms = [];
      this.rows = [];
      this.vendor = null;
    },
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "InterfaceBcafinController") {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    backForm() {
      window.location.href = "/flux-oms/asn-inbound";
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
    showToast(text, type) {
      this.$toast.open({
        type: type,
        position: "top-right",
        message: text,
        duration:10000
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loadVendor();
    this.loadSku();
  },
};
</script>

<style scoped>
.required:after {
  content: " *";
  color: red;
}
</style>
